import styled, { css } from 'styled-components';
import { TrevorIcon } from '../TrevorIcon';

export const SwitchButtonContainer = styled.div<{ checked: boolean }>`
  --l-padding: var(--spacing-l);
  --l-margin: 44px;
  background: ${(p) =>
    p.checked
      ? 'var(--color-feedback-success-lighter)'
      : 'var(--color-interface-layout-normal)'};
  width: fit-content;
  border-radius: var(--radius-100);
  height: 40px;
  min-width: 68px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: var(--l-padding);

  > p {
    margin-left: var(--l-margin);
    margin-right: 0;
    color: var(--color-interface-secondary-normal);
    font-weight: 700;
    font-size: 12px;
    line-height: 17px;
  }

  ${(p) =>
    p.checked &&
    css`
      padding-left: var(--l-padding);
      padding-right: 0;

      > p {
        margin-left: 0;
        margin-right: var(--l-margin);
      }

      > div {
        left: 100%;
        transform: translateX(calc(-100% - calc(var(--spacing-xxs) * 2)));
      }
    `};
`;

export const SwitchButton = styled.div`
  background: var(--color-interface-neutral-light);
  box-shadow: var(--elevation-soft);
  height: var(--spacing-xl);
  width: var(--spacing-xl);
  border-radius: 50%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;

  left: 0;
  transform: translateX(calc(var(--spacing-xxs) * 2));
  transition-duration: var(--transition-fast);

  > svg {
    color: var(--color-interface-secondary-normal);
  }
`;

export const SwitchLoading = styled(TrevorIcon).attrs({
  name: 'spinner',
  size: 'md',
})`
  animation: loading 3s linear infinite;
  color: var(--color-interface-secondary-normal);

  @keyframes loading {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  gap: calc(var(--spacing-xxs) * 2);
  width: max-content;
  align-items: center;
`;
